// Temporary hold while Google reviews the connected-app OAuth scopes.
// Keep packages, saved installs and credentials intact for re-enablement.
const pendingPlugins = new Set([
  'bundled:gmail-connected',
  'bundled:google-drive-connected',
  'bundled:google-calendar-connected',
]);
const pendingServers = new Set(['gmail', 'google-drive', 'google-calendar']);
const isUnavailablePlugin = id => pendingPlugins.has(id);
const isUnavailableServer = id => pendingServers.has(id);
module.exports = { isUnavailablePlugin, isUnavailableServer };
